import {Navigate, useRouteError } from "react-router-dom";
import * as React from "react"

export default function ErrorPage() {
  const error = useRouteError() as any;
  console.error(error);
  const statusText = "statusText" in error ? error?.statusText : "";
  const message = "message" in error ? error?.message : "";
  const statusCode = error?.response?.status

  if (statusCode === 401) {
    return <Navigate to={"/login?next=" + window.location.pathname} />
  }

  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{statusText || message}</i>
      </p>
      <a href="/">Return to the dashboard</a>
    </div>
  );
}